import {
  DropdownCountry1,
  createCountryStore,
} from '@/components/DropdownCountry'
import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import useSWR from 'swr'
import DeviceDropdown, { createDeviceStore } from './DropdownDevice'
import SkuDropdown, { createSkuIdStore } from './DropdownSku'

import { Button } from '@/components/ui/button'
import { createColumnVisibilityStore } from '@/components/zthd/data-table'
import { DataTableViewOptions } from '@/components/zthd/data-table-view-options'
import DataTableWithBorder from '@/components/zthd/data-table/data-table-with-border'
import {
  getCoreRowModel,
  getFilteredRowModel,
  useReactTable,
} from '@tanstack/react-table'
import { useColumnFilters } from '@/components/data-table-selectors'
import dayjs from 'dayjs'
import {
  cancelColumn,
  freeTryColumn,
  paidColumn,
  refundColumn,
  renewColumn,
} from './columns'

const CACHE_KEY = 'event2roadmap'
const useColumnVisibilityStore = createColumnVisibilityStore({}, CACHE_KEY)

const useSkuId = createSkuIdStore('1634387596', CACHE_KEY)
const useCountry = createCountryStore('US', CACHE_KEY)
const useDevice = createDeviceStore('total', CACHE_KEY)

const eventAtColumn = {
  id: 'eventAt',
  header: 'Event At',
  accessorFn: (row) => {
    const subAt = row.subAt
    const eventAt = row.eventAt
    const eventDay = dayjs(eventAt.toString(), 'YYYYMMDD')
    const subDay = dayjs(subAt.toString(), 'YYYYMMDD')
    const diffDays = eventDay.diff(subDay, 'day')
    return { subAt, eventAt, diffDays }
  },
  cell: (row) => {
    const { eventAt, diffDays } = row.getValue()
    return (
      <div className="flex flex-col">
        {eventAt} ({diffDays}day)
      </div>
    )
  },
}

const EventsRoadmap = () => {
  const { subAt } = useParams()
  const skuId = useSkuId((state) => state.value)
  const updateSkuId = useSkuId((state) => state.update)

  const country = useCountry((state) => state.value)
  const updateCountry = useCountry((state) => state.update)

  const device = useDevice((state) => state.value)
  const updateDevice = useDevice((state) => state.update)

  const {
    data: events,
    mutate,
    isValidating,
  } = useSWR([`/apple/events2/${subAt}/roadmap`, { pid: 12, country, skuId }])

  const { columnVisibility, setColumnVisibility } = useColumnVisibilityStore()
  const { columnFilters } = useColumnFilters()

  const data = useMemo(() => {
    if (!events) return []
    const events1 = events.filter((e) => e[device] > 0)
    const uniqueAts = [...new Set(events1.map((item) => item.eventAt))]
    const freeTry =
      events1.find((e) => e.event === 'Start Introductory Offer')?.[device] || 0

    return uniqueAts.map((eventAt) => {
      const eventAtEvents = events1
        .filter((item) => item.eventAt === eventAt)
        .map(({ event, [device]: value }) => ({
          event,
          value,
        }))

      return {
        eventAt,
        subAt,
        events: eventAtEvents,
        freeTry,
      }
    })
  }, [subAt, events, device])

  const columns = useMemo(() => {
    const rows = []
    rows.push(eventAtColumn)
    // rows.push(dnuColumn)
    rows.push(freeTryColumn)
    rows.push(paidColumn)
    rows.push(refundColumn)
    rows.push(renewColumn)
    rows.push(cancelColumn)
    // rows.push(billRetryColumn)
    // rows.push(reactivateColumn)
    // rows.push(gracePeriodColumn)
    return rows
  }, [])

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    onColumnVisibilityChange: setColumnVisibility,
    enableMultiRowSelection: true,
    state: {
      columnFilters,
      columnVisibility,
    },
  })

  return (
    <>
      <div className="flex items-center gap-4 py-4 flex-wrap sm:gap-2 sm:py-2">
        <DropdownCountry1 value={country} update={updateCountry} />
        <SkuDropdown value={skuId} update={updateSkuId} />
        <DeviceDropdown value={device} update={updateDevice} />
        <Button onClick={() => mutate()}>
          refresh{isValidating ? '...' : ''}
        </Button>
        <DataTableViewOptions table={table} />
      </div>
      <div>user subat {subAt}, then event at list.</div>
      <DataTableWithBorder table={table} />
    </>
  )
}

export default EventsRoadmap
